module.exports = __webpack_public_path__ + "media/images/icons/country_flags/om-95a4163591dd9474d246789378255500.svg";